import { useAPIAction, useLogout, UserAccountApi } from "melco-shared-logic";
import { Button } from "melco-ui";
import { useTranslation } from "react-i18next";
//import { useNavigate, } from "react-router-dom";
type propsss = {
  productCode: string;
}
const DeclineServiceTermsButton: React.FC<propsss> = ({ productCode }) => {
  // const { productCode } = useParams<{ productCode: string }>();
  const { t } = useTranslation();
  //  const navigate = useNavigate();

  const [logout, isLoggingOut] = useLogout();

  const [handleDecline, isLoading] = useAPIAction(
    UserAccountApi,
    async (api) => {
      await api.accountServiceTermsDecline({ productCode: productCode! });
      await logout({ dontResetUser: true });
      window.location.reload()
      // navigate("/login");
    },
    { translationPrefix: "global" }
  );

  return (
    <Button loading={isLoading} onClick={handleDecline}>
      {t("dashboard.apps.legal_policy.cancel")}
    </Button>
  );
};

export default DeclineServiceTermsButton;
